<button mat-icon-button [type]="type" (click)="onClick($event)">
  <mat-icon color="primary">{{ icon }}</mat-icon>
</button>
